import { API_REQUEST_TYPES } from "../../enums";
import { resetApi } from "../../services/axios";
import { setListData, setListLoading } from "../../store/modules/lists";
import {
  setAppSettings,
  setAppSettingsLoading,
} from "../../store/modules/UI";
import { API } from "../endpoints";

export function getIndustryList() {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.GET,
        url: API.COMMON.GET_INDUSTRIES,
        payload: {},
        config: {
          validateUser: false,
          loadingFn: (loading) =>
            setListLoading({
              list: "industries",
              loading,
            }),
        },
      })
    );

    if (res.success) {
      dispatch(
        setListData({
          list: "industries",
          data: res.data,
        })
      );
    }

    return res;
  };
}

export function getTitleList() {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.GET,
        url: API.COMMON.GET_TITLES,
        payload: {},
        config: {
          validateUser: false,
          loadingFn: (loading) =>
            setListLoading({
              list: "titles",
              loading,
            }),
        },
      })
    );

    if (res.success) {
      dispatch(
        setListData({
          list: "titles",
          data: res.data,
        })
      );
    }

    return res;
  };
}

export function getTimezoneList() {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.GET,
        url: API.COMMON.GET_TIMEZONES,
        payload: {},
        config: {
          validateUser: false,
          loadingFn: (loading) =>
            setListLoading({
              list: "timezones",
              loading,
            }),
        },
      })
    );

    if (res.success) {
      dispatch(
        setListData({
          list: "timezones",
          data: res?.data?.filter((item) => item?.utc?.length > 0),
        })
      );
    }

    return res;
  };
}

export function getCategoryList() {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.GET,
        url: API.COMMON.GET_CATEGORIES,
        payload: {},
        config: {
          validateUser: false,
          loadingFn: (loading) =>
            setListLoading({
              list: "categories",
              loading,
            }),
        },
      })
    );

    if (res.success) {
      dispatch(
        setListData({
          list: "categories",
          data: res.data,
        })
      );
    }

    return res;
  };
}

export function getNoOfEmpList() {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.GET,
        url: API.COMMON.GET_NO_OF_EMP,
        payload: {},
        config: {
          validateUser: false,
          loadingFn: (loading) =>
            setListLoading({
              list: "no_of_emps",
              loading,
            }),
        },
      })
    );

    if (res.success) {
      dispatch(
        setListData({
          list: "no_of_emps",
          data: res.data,
        })
      );
    }

    return res;
  };
}

export function getTopicList() {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.GET,
        url: API.COMMON.GET_TOPICS,
        payload: {},
        config: {
          validateUser: false,
          loadingFn: (loading) =>
            setListLoading({
              list: "topics",
              loading,
            }),
        },
      })
    );

    if (res.success) {
      dispatch(
        setListData({
          list: "topics",
          data: res.data,
        })
      );
    }

    return res;
  };
}

export function getOpportunityCategoryList() {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.GET,
        url: API.COMMON.GET_OPPORTUNITY_CATEGORIES,
        payload: {},
        config: {
          validateUser: false,
          loadingFn: (loading) =>
            setListLoading({
              list: "opportunity_categories",
              loading,
            }),
        },
      })
    );

    if (res.success) {
      dispatch(
        setListData({
          list: "opportunity_categories",
          data: res.data,
        })
      );
    }

    return res;
  };
}

export function getCurrentAppSettings() {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.GET,
        url: API.COMMON.GET_APP_SETTINGS_CURRENT,
        payload: {},
        config: {
          loadingFn: (loading) => setAppSettingsLoading(loading),
        },
      })
    );

    if (res?.success) {
      dispatch(setAppSettings(res?.data));
    }

    return res;
  };
}

export function getCountries() {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.GET,
        url: API.COMMON.GET_COUNTRIES_LIST,
        payload: {},
        config: {
          notifyError: false,
          validateUser: false,
          externalUrl: true,
          loadingFn: (loading) =>
            setListLoading({
              list: "countries",
              loading,
            }),
        },
      })
    );

    if (!res.error) {
      dispatch(
        setListData({
          list: "countries",
          data: res?.data,
        })
      );
    }

    return res;
  };
}

export function getStateList(payload) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.POST,
        url: API.COMMON.GET_STATES,
        payload,
        config: {
          notifyError: false,
          validateUser: false,
          externalUrl: true,
          loadingFn: (loading) =>
            setListLoading({
              list: "states",
              loading,
            }),
        },
      })
    );

    if (!res.error) {
      const statesList = res?.data?.states ?? [];
      dispatch(
        setListData({
          list: "states",
          data: statesList,
        })
      );
    }else{
      dispatch(
        setListData({
          list: "states",
          data: [],
        })
      );
    }

    return res;
  };
}
